var exports = {
  "s": "x7f9a0e16--852056--bottom",
  "R": "x7f9a0e16--852056--visible",
};

module.exports = exports;
